




























































































import Vue from "vue";
import InteractionState from "@/Globals/InteractionState";
export default Vue.extend({
  data() {
    return {
      animationDone: false,
      preludeDone: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.$data.animationDone = true;
      setTimeout(() => {
        this.$data.preludeDone = true;
      }, 400);
    }, 3700);
  },
  methods: {
    goBack() {
      this.$data.preludeDone = false;
      setTimeout(() => {
        this.$data.animationDone = false;
        this.$store.commit("changeState", InteractionState.Root);
      }, 550);
    }
  }
});
